// TYP časové řady z endpointu to_fill položky (viz doc/plans/to-fill-human-labels.md).
// TYP + ts_id je jednoznačný klíč pro /api/ts_info — ts_id se napříč spec tabulkami kříží.
//
//   /api/daily_ts/fill   → DAILY   (daily_ts_spec, obs_type 10M/HLY/DLY)
//   /api/sdata_ts/fill    → SDATA   (sdata_ts_spec)
//   /api/sndata_ts/fill   → SDATA   (sdílená sdata_ts_spec)
//   /api/sedata_ts/fill   → SEDATA  (sedata_ts_spec)

export function typFromEndpoint(endpoint) {
  const e = String(endpoint || '')
  if (e.includes('/sedata_ts/')) return 'SEDATA'
  if (e.includes('/sdata_ts/') || e.includes('/sndata_ts/')) return 'SDATA'
  return 'DAILY'
}
